import { render, staticRenderFns } from "./ShiftTable.vue?vue&type=template&id=b945dcc8&scoped=true"
import script from "./ShiftTable.vue?vue&type=script&lang=js"
export * from "./ShiftTable.vue?vue&type=script&lang=js"
import style1 from "./ShiftTable.vue?vue&type=style&index=1&id=b945dcc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b945dcc8",
  null
  
)

export default component.exports